export const comments_5160002 = {"data":{"data":[],"links":{}}}